import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ec2Get } from '../utils/ec2api';
import './Notificaciones.css';

export default function Notificaciones() {
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [latest, setLatest] = useState(null);
  const [countdown, setCountdown] = useState(60);
  const navigate = useNavigate();

  useEffect(() => {
    ec2Get('/notifs')
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        setNotifs(list);
        if (list.length > 0) {
          const newest = list[0];
          const age = Date.now() - new Date(newest.created_at).getTime();
          if (age < 5 * 60 * 1000) setLatest(newest);
        }
      })
      .catch(() => setNotifs([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!latest || !latest.url || latest.url === '/') return;
    if (countdown <= 0) { navigate(latest.url); return; }
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, latest, navigate]);

  if (loading) return <div className="notif-page"><div className="notif-empty">Cargando...</div></div>;

  return (
    <div className="notif-page">
      {latest && (
        <div className="notif-splash">
          <div className="notif-splash-icon">🔔</div>
          <h1 className="notif-splash-title">{latest.titulo}</h1>
          <p className="notif-splash-body">{latest.mensaje}</p>
          {latest.url && latest.url !== '/' && (
            <>
              <button className="notif-splash-btn" onClick={() => navigate(latest.url)}>Ver ahora</button>
              <p className="notif-splash-countdown">Redirigiendo en {countdown}s...</p>
            </>
          )}
        </div>
      )}
      <div className="notif-hero">
        <h1>🔔 Notificaciones</h1>
        <p>Tus mensajes y promociones recientes</p>
      </div>
      {notifs.length === 0 ? (
        <div className="notif-empty">No tienes notificaciones aún</div>
      ) : (
        notifs.map((n) => (
          <div className="notif-card" key={n.id}>
            <p className="notif-card-title">{n.titulo}</p>
            <p className="notif-card-body">{n.mensaje}</p>
            <span className="notif-card-time">{new Date(n.created_at).toLocaleString()}</span>
            {n.url && n.url !== '/' && (
              <div><Link to={n.url} className="notif-card-link">Ver más</Link></div>
            )}
          </div>
        ))
      )}
    </div>
  );
}
